import React, { useMemo, useState, useEffect } from "react";

import { DatePickerFromToUnionProps } from "types";

import DatePicker from ".";


const DatePickerFromTo = ({
	connectDatePickerFn,
	connectionName = "",
	name,
	value,
	placeholderText,
	className,
	wrapperClassName,
	onChange,
	onBlur,
	onFocus,
	minDate,
	maxDate,
	tabIndex,
	disabled,
}: DatePickerFromToUnionProps) => {
	const [dataValue, setDateValue] = useState<Date | null | undefined>();
	const { fromValue, toValue, setFromValue, setToValue } = useMemo(
		() => connectDatePickerFn?.(connectionName) || {},
		[connectDatePickerFn, connectionName],
	);

	useEffect(() => {
		if (!value && dataValue) {
			setFromValue?.(null);
			setToValue?.(null);
			setDateValue(null);
		}
	}, [
		dataValue,
		fromValue,
		maxDate,
		setFromValue,
		setToValue,
		toValue,
		value,
	]);

	return (
		<DatePicker
			name={name}
			value={value}
			dateFormat="MM/dd/yyyy"
			onChange={(newValue, event) => {
				setFromValue?.(newValue);
				setToValue?.(newValue);
				setDateValue?.(newValue);
				onChange?.(newValue, event);
			}}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholderText={placeholderText}
			className={className}
			wrapperClassName={wrapperClassName}
			minDate={fromValue || minDate}
			maxDate={toValue || maxDate}
			tabIndex={tabIndex}
			disabled={disabled}
			autoComplete="off"
		/>
	);
};

export default DatePickerFromTo;
